import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const reviews = [{
  name: 'María Elena R.',
  location: 'Ciudad de México',
  initial: 'M',
  rating: 5,
  text: 'Una guía hermosa y muy bien explicada. La leí en una tarde y enseguida empecé a aplicar la rutina. Me encanta lo organizada y clara que está. Vale cada centavo.'
}, {
  name: 'Carmen S.',
  location: 'Bogotá',
  initial: 'C',
  rating: 5,
  text: 'Compré la guía pensando que sería algo básico, pero me sorprendió muchísimo. Los checklists son prácticos y los bonos son un plus increíble. La recomiendo totalmente.'
}, {
  name: 'Lucía F.',
  location: 'Madrid',
  initial: 'L',
  rating: 5,
  text: 'Llevo dos semanas siguiendo la rutina y siento más calma cada noche. Es exactamente lo que necesitaba: simple, clara y en español. El plan de 7 días me ayudó a no abandonar.'
}, {
  name: 'Ana Patricia M.',
  location: 'Lima',
  initial: 'A',
  rating: 5,
  text: 'El diseño es precioso y el contenido va al grano. Me gusta poder consultarla desde el celular cuando la necesito. La guía de calzado me abrió los ojos sobre lo que estaba comprando.'
}, {
  name: 'Rosa V.',
  location: 'Buenos Aires',
  initial: 'R',
  rating: 5,
  text: 'Perfecta para quienes queremos hábitos sin complicaciones. Lo descargué de inmediato después de comprarlo y empecé esa misma noche. Me siento más conectada con mi cuidado personal.'
}, {
  name: 'Beatriz O.',
  location: 'Santiago',
  initial: 'B',
  rating: 5,
  text: 'Una compra que realmente vale la pena. La rutina de la mañana se volvió mi momento favorito del día. Gracias por crear algo tan útil y bonito a la vez.'
}];
export function Reviews() {
  return <section className="py-24 bg-cream" data-id="element-235">
      <div className="max-w-6xl mx-auto px-6" data-id="element-236">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-238">
            Lo que dicen nuestras lectoras
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto mb-6" data-id="element-239" />

          {/* Star summary */}
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-240">
            <div className="flex" data-id="element-241">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-bronze text-bronze" data-id="element-242" />)}
            </div>
            <span className="font-serif text-xl text-charcoal font-semibold" data-id="element-243">
              5.0
            </span>
          </div>
          <p className="text-charcoal-light text-sm" data-id="element-244">
            Basado en reseñas verificadas de clientas
          </p>
        </motion.div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-245">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative bg-white border border-bronze/15 p-7 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-246">
              {/* Decorative quote icon */}
              <QuoteIcon className="absolute top-4 right-4 w-8 h-8 text-bronze/15" data-id="element-247" />

              {/* Stars */}
              <div className="flex mb-4" data-id="element-248">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-bronze text-bronze" data-id="element-249" />)}
              </div>

              {/* Review text */}
              <p className="text-charcoal-light leading-relaxed mb-6 text-sm" data-id="element-250">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-bronze/10" data-id="element-251">
                <div className="w-10 h-10 rounded-full bg-bronze/20 flex items-center justify-center font-serif text-bronze-dark font-semibold" data-id="element-252">
                  {review.initial}
                </div>
                <div data-id="element-253">
                  <p className="font-medium text-charcoal text-sm" data-id="element-254">
                    {review.name}
                  </p>
                  <p className="text-xs text-charcoal-light" data-id="element-255">
                    {review.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust line */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mt-12" data-id="element-256">
          <p className="text-charcoal-light italic font-serif" data-id="element-257">
            ✨ Únete a cientos de mujeres que ya transformaron su rutina diaria
          </p>
        </motion.div>
      </div>
    </section>;
}